import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import mixins from '@mixins/global';
import VueGoogleCharts from 'vue-google-charts';
import { mask } from 'vue-the-mask';
import * as VueGoogleMaps from 'vue2-google-maps';
import '@components/base/index';
import '@plugins/axios';
import '@plugins/vee-validate';

// css
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'nprogress/nprogress.css';
import '@assets/css/main.css';

Vue.config.productionTip = false;
Vue.mixin(mixins);
Vue.directive('mask', mask);

// google chart
Vue.use(VueGoogleCharts);

// google maps
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_G_MAPS_KEY,
    libraries: 'places,drawing,geometry',
    language: 'id',
  },
  installComponents: true,
});

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (let registration of registrations) {
      registration
        .unregister()
        .then(function () {
          return self.clients.matchAll();
        })
        .then(function (clients) {
          clients.forEach((client) => {
            if (client.url && 'navigate' in client) client.navigate(client.url);
          });
        });
    }
  });
}

export default new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
